
const INIT_STATE = {
    prodGroupList : [],
    prodGroupListPop : [],
    prodGroupListPopCnt : [],
    commonCodeDtl : [{
        cdTyId: '',
        cdVal : '',
        cmnCdNm : ''
    }],
    prdtCodeList : [],
    list : [],
    rows : 0,
    targetRow : 0,
    popList : [],
    popRows : 0,
    popTargetRow : 0,
    popPrdtCodeList : [],
    prodOrderList : [],
    prodOrderRows : 0,
    prodOrderTargetRow : 0,
    riderSortList : [],
    riderSortListRows : 0,

    salempsAgncReged : {
        list : [],
        rows : 0,
        targetRow : 0,
        prdtList : [],
    },
    salempsAgncRegedMod : {
        list : [],
        rows : 0,
        targetRow : 0,
        prdtList : [],
    },
    saleImpsAgncReg : {
        list : [],
        rows : 0,
        targetRow : 0,
    },
    saleImpsAgncRegMod : {
        list : [],
        rows : 0,
        targetRow : 0,
    },
    prodSaleQuitMethod : [],

}

const managementProductReducer = (state=INIT_STATE, action) => {
    switch(action.type){
        case 'INIT_STATE' : {
            return INIT_STATE;
        }
        case 'GET_PROD_GROUP_LIST_SUCCESS' : {
            return {
                ...state,
                prodGroupList : action.payload.prodGroupList,
            };
        }
        case 'GET_PROD_GROUP_LIST_POP_SUCCESS' : {
            return {
                ...state,
                prodGroupListPop : action.payload.prodGroupListPop,
            };
        }
        case 'GET_PROD_GROUP_CNT_SUCCESS' : {
            return {
                ...state,
                prodGroupListPopCnt : action.payload.prodGroupListPopCnt,
            };
        }
        case 'PRDT_GET_COMMON_CODE_DTL_LIST_SUCCESS' : {
            return {
                ...state,
                commonCodeDtl : [...action.payload.commonCodeDtl]
            };
        }
        case 'PRDT_SEARCH_BY_CHANNEL_SUCCESS' : {
            return {
                ...state,
                prdtCodeList : [...action.payload.prdtCodeList]
            };
        }
        case 'GET_PROD_LIST_SUCCESS' : {
            return {
                ...state,
                ...action.payload,
            };
        }
        case 'GET_PROD_LIST_POP_SUCCESS' : {
            return {
                ...state,
                ...action.payload,
            };
        }
        case 'PRDT_SEARCH_BY_CHANNEL_POP_SUCCESS' : {
            return {
                ...state,
                popPrdtCodeList : [...action.payload.popPrdtCodeList]
            };
        }
        case 'GET_PROD_ORDER_LIST_SUCCESS' : {
            return {
                ...state,
                prodOrderList : action.payload.prodOrderList,
                prodOrderRows : action.payload.prodOrderRows,
                prodOrderTargetRow : action.payload.prodOrderTargetRow,
            };
        }
        case 'GET_RIDER_SORT_LIST_SUCCESS' : {
            return {
                ...state,
                riderSortList : action.payload.riderSortList,
                riderSortListRows : action.payload.riderSortListRows
            };
        }
        case 'GET_RIDER_SORT_LIST_CLEAR' : {
            return {
                ...state,
                riderSortList : [],
                riderSortListRows : 0,
            };
        }
        case 'GET_PROD_LIST_POP_CLEAR' : {
            return {
                ...state,
                popList : [],
                popRows : 0,
                popTargetRow : 0,
                // popPrdtCodeList : [],
            };
        }
        case 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR' : {
            return {
                ...state,
                salempsAgncReged : {
                    list : [],
                    rows : 0,
                    targetRow : 0,
                    prdtList : [],
                }
            }
        }
        case 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS' : {
            return {
                ...state,
                salempsAgncReged : {
                    ...state.salempsAgncReged,
                    ...action.payload.salempsAgncReged
                }
            }
        }
        case 'GET_PROD_SALE_IMPS_AGNC_REGED_LIST_SUCCESS_MOD' : {
            return {
                ...state,
                salempsAgncRegedMod : {
                    ...state.salempsAgncRegedMod,
                    ...action.payload.salempsAgncRegedMod
                }
            }
        }
        case 'PROD_SALE_IMPS_AGNC_REGED_LIST_MOD_CLEAR' : {
            return {
                ...state,
                salempsAgncRegedMod : {
                    list : [],
                    rows : 0,
                    targetRow : 0,
                    prdtList : [],
                },
            }
        }
        case 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR_MOD' : {
            return {
                ...state,
                saleImpsAgncRegMod : {
                    list : [],
                    rows : 0,
                    targetRow : 0,
                },
            }
        }

        case 'PROD_SALE_IMPS_AGNC_REGED_LIST_CLEAR' : {
            return {
                ...state,
                salempsAgncReged : {
                    list : [],
                    rows : 0,
                    targetRow : 0,
                    prdtList : [],
                },
            }
        }
        case 'GET_PRDT_BY_CHANNEL_SUCCESS' : {
            return {
                ...state,
                salempsAgncReged : {
                    ...state.salempsAgncReged,
                    prdtList : action.payload.prdtList
                }
            }
        }
        case 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS' : {
            return {
                ...state,
                saleImpsAgncReg : {...action.payload.saleImpsAgncReg}
            }
        }
        case 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_SUCCESS_MOD' : {
            return {
                ...state,
                saleImpsAgncRegMod : {...action.payload.saleImpsAgncRegMod}
            }
        }
        case 'GET_PROD_SALE_IMPS_AGNC_REG_LIST_CLEAR' : {
            return {
                ...state,
                saleImpsAgncReg : {
                    list : [],
                    rows : 0,
                    targetRow : 0,
                }
            }
        }
        case 'GET_PROD_SALE_QUIT_METHOD_CD_SUCCESS' : {
            return {
                ...state,
                prodSaleQuitMethod : action.payload.prodSaleQuitMethod
            }
        }
        
        default :
            return state;
    }
}

export default managementProductReducer;